import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
  transform(val: any, args?: any): any {
    if (val !== undefined && val !== null) {
      
      var viewVal = val.trim().replace(/^\+/, '');
      var area, number;
      switch (viewVal.length) {
        case 1:
        case 2:
        case 3:
          area = viewVal;
          break;
        default:
          area = viewVal.slice(0, 3);
          number = viewVal.slice(3);
      }
      if (number) {
        if (number.length > 3) {
          number = number.slice(0, 3) + '-' + number.slice(3, 7);
        } else {
          number = number;
        }
        if (args === 1) {
         // return ("(" + area + ")" + '-' + number).trim().slice(0, 14);
         return ("(" + area + ")" + number).trim().slice(0, 14);
        }
        if (args === 2) {
          return (area + '-' + number).trim().slice(0, 13);
        }
      } else {
        return  area;
      }
    }
  }
  

}
